import React from "react";
import { Table, Form } from "antd";
import BannerCard from "../../../common/components/BannerCard";
import CleanButton from "../../../common/components/CleanButton";
import { Tooltips } from "../../../common/constants/Tooltips";
import CaseBalanceViolationModal from "../case-balance/case-balance-violation-modal";
import useCaseBalance from "../case-balance/useCaseBalance";

const CaseSummaryViolations = ({ ...props }) => {
  const { data, loading } = props;
  const [form] = Form.useForm();
  const { isModalOpen, setIsModalOpen, violationDetails, handleViolationView } = useCaseBalance();

  const columns = [
    { key: "case", title: "Violation Case", dataIndex: "VIOLATION_CASE" },
    { key: "offense", title: "Offense", dataIndex: "OFFENSE" },
    { key: "violationDate", title: "Violation Date", dataIndex: "VIOLATION_DATE" },
    { key: "ticket", title: "Ticket", dataIndex: "TICKET" },
    { key: "unpaidAmount", title: "Unpaid Amount", dataIndex: "UNPAID_AMOUNT" },
    { key: "waiverAmount", title: "Waiver Amount", dataIndex: "WAIVER_AMOUNT" },
    { key: "actions", title: "Actions", dataIndex: "VIOLATION_CASE", render: (val) => <CleanButton icon="eye" type="link" tooltip={Tooltips.View} onClick={() => handleViolationView(val)} /> }
  ];

  return (
    <BannerCard title="Balance Violation">
      <Table loading={loading} dataSource={data} columns={columns} scroll={{ x: 720 }} />
      <span style={{ float: "right" }}>Waiver amount may be paid by arraignment/court date.</span>
      <CaseBalanceViolationModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} violationDetails={violationDetails} form={form} />
    </BannerCard>
  );
};

export default CaseSummaryViolations;
